import React from 'react';
import SelectComponent from '../../../atoms/Select';
import {roleTypes} from '../../../../utils/types';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../store/rootReducer';
import {formatString} from "../../../../utils/helpers";
import {Card} from "antd";

interface FormProps {
    role: string;
    required?: boolean;
    onTypeChange: (value: string) => void;
}

const SelectRoleForm: React.FC<FormProps> = ({role, required, onTypeChange}) => {
    const currentUser = useSelector((state: RootState) => state);
    const roleTypes: roleTypes[] = (currentUser.auth.user?.roles || []) as roleTypes[];

    const transformedRoleTypes = roleTypes.map(e => ({
        label: formatString(e.roleType), value: e.roleType
    }));

    const defaultRole = role && role !== 'null' ? role : (transformedRoleTypes[0]?.value || '');

    return (
        <Card bordered={false} title={<span style={{color: '#1677ff', fontWeight: 'bold', fontSize: '20px'}}>Select user role</span>}>
                <SelectComponent label={''} value={defaultRole} placeholder={''}
                                 onChange={onTypeChange} options={transformedRoleTypes} required={required}
                                 showSearch={true}></SelectComponent>
        </Card>
    );
};

export default SelectRoleForm;